import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  ViewCollmanServerData,
  AddToFavouritesParams,
  RemoveFromFavouritesParams,
  ReportsViewParams,
  ReportsViewServerData,
  PrintReportingParams,
} from '@lk/api'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'

export const view = createAsyncThunk<unknown, void, ThunkApi>(
  '[REPORTING] VIEW',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.view()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)

export const destroyReporingViewData = createAction('[REPORTING] DESTROY_REPORTING_VIEW_DATA')

export const viewCollman = createAsyncThunk<ViewCollmanServerData, void, ThunkApi>(
  '[REPORTING] VIEW_COLLMAN',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.viewCollman()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)
export const viewLoan = createAsyncThunk<unknown, void, ThunkApi>(
  '[REPORTING] VIEW_LOAN',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.viewLoan()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)
export const viewApplication = createAsyncThunk<unknown, void, ThunkApi>(
  '[REPORTING] VIEW_APPLICATION',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.viewApplication()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)
export const viewCollateral = createAsyncThunk<unknown, void, ThunkApi>(
  '[REPORTING] VIEW_COLLATERAL',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.viewCollateral()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)
export const viewClient = createAsyncThunk<unknown, void, ThunkApi>(
  '[REPORTING] VIEW_CLIENT',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.viewClient()

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)

export const printReporting = createAsyncThunk<unknown, PrintReportingParams & { page: string }, ThunkApi>(
  '[REPORTING] PRINT_REPORT',
  async ({ page, ...params }, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.printReporting(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view collman')
  },
)

export const addToFavourites = createAsyncThunk<void, AddToFavouritesParams, ThunkApi>(
  '[REPORTING] ADD_TO_FAVOURITES',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.addToFavourites(params)

    if (!result.success) {
      dispatch(LKModalActions.openError(result.error.message))
      return rejectWithValue('Failed to add the report to favourites')
    }
  },
)

export const removeFromFavourites = createAsyncThunk<void, RemoveFromFavouritesParams, ThunkApi>(
  '[REPORTING] REMOVE_FROM_FAVOURITES',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.removeFromFavourites(params)

    if (!result.success) {
      dispatch(LKModalActions.openError(result.error.message))
      return rejectWithValue('Failed to remove the report to favourites')
    }
  },
)

export const generate = createAsyncThunk<void, any, ThunkApi>(
  '[REPORTING] GENERATE',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.generate(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to generate the report')
  },
)

export const reportsView = createAsyncThunk<ReportsViewServerData, ReportsViewParams, ThunkApi>(
  '[REPORTING] REPORTS_VIEW',
  async (params, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.reporting.reportsView(params)

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))
    return rejectWithValue('Failed to view report')
  },
)
